import type { Patient } from '@/types/api';

/** Protocol details (#23) a patient still lacks, as `patients.form.*` label keys. */
export type MissingField = 'parentName' | 'birthDate' | 'sex' | 'idNumber' | 'address' | 'phone';

/** What the protocol needs and this patient (recorded before #23) does not have yet. */
export function missingProtocolFields(
  p: Pick<Patient, 'parentName' | 'birthDate' | 'sex' | 'jmbg' | 'lbo' | 'address' | 'phone'>
): MissingField[] {
  const missing: MissingField[] = [];
  if (!p.parentName) missing.push('parentName');
  if (!p.birthDate) missing.push('birthDate');
  if (!p.sex) missing.push('sex');
  if (!(p.jmbg || p.lbo)) missing.push('idNumber');
  if (!p.address) missing.push('address');
  if (!p.phone) missing.push('phone');
  return missing;
}
